import { ConfirmationService } from "primeng/api";
import { TranslateService } from "@ngx-translate/core";
import { Injectable } from "@angular/core";

@Injectable()
export class AlertUtil {

    constructor(private confirmationService: ConfirmationService,
        private translate: TranslateService) {
    }


    /**
     * show alert
     * @param messageKey text of message
     * @param messageParams params for the message
     * @param headerKey text of header
     * @param buttonAcceptKey text of button
     * @param callback callback
     */
    showAlert(messageKey: string, messageParams?: any, headerKey?: string, buttonAcceptKey?: string, callback?: any) {
        buttonAcceptKey = !buttonAcceptKey ? "LBL_OK" : buttonAcceptKey
        headerKey = !headerKey ? "LBL_APP_NAME" : headerKey
        this.translate.get([headerKey, messageKey, buttonAcceptKey], messageParams).subscribe((res: string[]) => {
            this.confirmationService.confirm({
                // key: 'info',
                header: res[headerKey],
                message: res[messageKey],
                icon: "pi pi-info-circle",
                rejectVisible: false,
                acceptLabel: res[buttonAcceptKey],
                accept: () => {
                    if (callback) {
                        callback()
                    }
                },
                reject: () => {
                    if (callback) {
                        callback()
                    }
                }
            });
        })

    }

    /**
     * show confirmation alert
     * @param messageKey text of message
     * @param messageParams params for the message
     * @param headerKey text of header 
     * @param buttonAcceptKey text accept button
     * @param buttonRejectKey text reject button
     * @param callbackOK ok callback
     * @param callbackKo ko callback
     */
    showConfirmationAlert(messageKey: string, messageParams?: any, headerKey?: string, buttonAcceptKey?: string, buttonRejectKey?: string, callbackOk?: any, callbackKo?: any) {
        headerKey = !headerKey ? "LBL_APP_NAME" : headerKey
        buttonAcceptKey = !buttonAcceptKey ? "LBL_OK" : buttonAcceptKey
        buttonRejectKey = !buttonRejectKey ? "LBL_REJECT" : buttonRejectKey
        this.translate.get([messageKey, headerKey, buttonAcceptKey, buttonRejectKey], messageParams).subscribe((res: string[]) => {
            this.confirmationService.confirm({
                // key: 'confirmation',
                message: res[messageKey],
                header: res[headerKey],
                icon: "pi pi-question-circle",
                rejectVisible: true,
                acceptLabel: res[buttonAcceptKey],
                rejectLabel: res[buttonRejectKey],
                accept: () => {
                    if (callbackOk) {
                        callbackOk()
                    }
                },
                reject: () => {
                    if (callbackKo) {
                        callbackKo()
                    }
                }
            });
        })
    }

     /**
     * show error alert
     * @param errorMessageKey text of message error
     * @param messageParams params for the message
     * @param headerKey text of header
     * @param buttonAcceptKey text of button
     * @param callback callback
     */
    showErrorAlert(errorMessageKey: string, messageParams?: any, headerKey?: string, buttonAcceptKey?: string, callback?: any) {
        buttonAcceptKey = !buttonAcceptKey ? "LBL_OK" : buttonAcceptKey
        headerKey = !headerKey ? "LBL_APP_NAME" : headerKey
        this.translate.get([headerKey, errorMessageKey, buttonAcceptKey], messageParams).subscribe((res: string[]) => {
            this.confirmationService.confirm({
                // key: 'error',
                header: res[headerKey],
                message: res[errorMessageKey],
                icon: "pi pi-exclamation-triangle",
                rejectVisible: false,
                acceptLabel: res[buttonAcceptKey],
                accept: () => {
                    if (callback) {
                        callback()
                    }
                }
            });
        })

    }
}